module.exports = __webpack_public_path__ + "static/media/nytimes.com_interactive_2016_01_28_upshot_donald-trump-twitter-insults.html_plot.a167dbae.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/nytimes.com_interactive_2016_01_28_upshot_donald-trump-twitter-insults.html_plot.png
// module id = 410
// module chunks = 0